import { Box } from '@mui/material';
import TableCard from 'lib/designSystem/Card/TableCard';
import { formatDate } from 'lib/functions/utils';
import React from 'react';

import { Request } from '../types';
import SummaryRow from './SummaryRow';

interface DetailsSummaryProps {
  request: Request;
}

const DetailsSummary: React.FC<DetailsSummaryProps> = ({ request }) => {
  const businessName = request.pendingAccounts?.[0]?.businessName || '';
  const businessIdentifier =
    request.pendingAccounts?.[0]?.businessIdentifier || '';

  const formatDateValue = (date: Date | string | undefined): string => {
    if (!date) return '-';
    return formatDate(date instanceof Date ? date : new Date(date));
  };

  return (
    <TableCard
      size="medium"
      enabledEffects={false}
      sx={{ boxShadow: 'none', border: 'none', background: 'transparent' }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <SummaryRow label="Destinatario" value={businessName} />
        <SummaryRow label="Rut cliente" value={businessIdentifier} />
        <SummaryRow
          label="Fecha de creación"
          value={formatDateValue(request.createdAt)}
        />
        <SummaryRow
          label="Fecha de operación"
          value={formatDateValue(request.executedAt)}
        />
      </Box>
    </TableCard>
  );
};

export default DetailsSummary;
